import { IconButton } from '@mui/material'
import { useSentinel } from '@contexts/Sentinel'

import BlurCircularOutlinedIcon from '@mui/icons-material/BlurCircularOutlined'

export function SentinelBadge() {
  const { isOpen, openSentinel } = useSentinel()

  const handleClickSentinel = () => {
    openSentinel()
  }

  if (isOpen) return null

  return (
    <IconButton color="secondary" onClick={handleClickSentinel}>
      <BlurCircularOutlinedIcon />
    </IconButton>
  )
}
